import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EmailKindPicker } from '../../../../components/entity-picker/email-kind-picker/EmailKindPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type IEmailKindFilterCardProps = {
  title: string;
  value: { id: string; name: string }[] | null;
  onChange: (value: { id: string; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const EmailKindFilterCard: React.FC<IEmailKindFilterCardProps> = (
  props
) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return t('FIELDS.values.kind.' + value[0].id);
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <EmailKindPicker
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </FilterCard>
  );
};
